import React from 'react';
import AsyncSelect from 'react-select/async';
import DbApi from 'api/db';

class SelectFromDB extends React.Component {
  state = {
    inputValue: '',
    value: null,
  };

  loadOptions = async (search = '') => {
    const { options = [], db_id, db_name, label, value, filter } = this.props.options || {};

    let datasets = [];

    if (db_id) {
      datasets = await DbApi.getDatasets(db_id, { search, filter });
    } else {
      console.log('db_name', db_name);
      datasets = await DbApi.getDatasetsByDbName(db_name, { search, filter });
    }

    const remoteOptions = datasets.rows.map(row => {
      const data = row.data;
      return {
        label: data[label],
        value: data[value] || data.id,
      };
    });

    return [...options, ...remoteOptions];
  };

  handleChange = value => {
    const { onChange } = this.props;
    this.setState({ value });

    if (onChange) {
      onChange(JSON.stringify(value));
    }
  };

  handleInputChange = newValue => {
    const inputValue = newValue.replace(/\W/g, '');
    this.setState({ inputValue });
    return inputValue;
  };

  render() {
    const { value, autofocus, required, placeholder, readonly, options, id } = this.props;
    const { multiple, clearable } = options;

    return (
      <>
        <AsyncSelect
          cacheOptions
          autoFocus={autofocus}
          loadOptions={this.loadOptions}
          defaultOptions
          placeholder={placeholder}
          required={required}
          readonly={readonly}
          isMulti={multiple}
          isClearable={clearable}
          onChange={this.handleChange}
          inputValue={this.state.inputValue}
          onInputChange={this.handleInputChange}
          defaultValue={value}
        />

        <input id={id} name={id} value={JSON.stringify(this.state.value)} type="hidden" />
      </>
    );
  }
}

export default SelectFromDB;
